import styled from 'styled-components';

import { COLORS } from '~/src/common/theme';

import { IconName } from './Icon.d';

interface Props extends Omit<React.HTMLAttributes<HTMLSpanElement>, 'color'> {
  name: IconName;
  size?: number;
  color?: keyof typeof COLORS | 'inherit' | (string & {});
  disabled?: boolean;
}

const isColor = (color: string): color is keyof typeof COLORS => color in COLORS;

const getAttrs = ({ name }: Props) => ({
  'className': `icon-${name}`,
  'aria-label': name,
  'name': undefined,
  'role': 'img',
});

const Icon = styled.span.attrs<Props>(getAttrs)<Props>`
  color: ${({ color = 'ACTION_DEFAULT' }) => (isColor(color) ? COLORS[color] : color)};
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
  font-size: ${({ size }) => (size != null ? `${size}px` : 'inherit')};
  cursor: ${({ onClick }) => (onClick ? 'pointer' : 'inherit')};
`;

export default Icon;
